import request from '../utils/request';

  /**数据中心-商品库看板商品统计表 */
  export function statisticDetailApi(params,authorization){
    return request({
      url: '/api/wx_shop/dataCenter/statisticDetail',
      method: 'post',
      data: params,
      headers: {
        "authorization": authorization
      }
    },true)
  }

  /**数据中心-商品库看板商城商品统计折线图*/
  export function productStatisticApi(params,authorization){
    return request({
      url: '/api/wx_shop/dataCenter/productStatistic',
      method: 'post',
      data: params,
      headers: {
        "authorization": authorization
      }
    },true)
  }

  /**数据中心-商品库看板商城商品统计 */
  export function productBarStatisticApi(params,authorization){
    return request({
      url: '/api/wx_shop/dataCenter/productBarStatistic',
      method: 'post',
      data: params,
      headers: {
        "authorization": authorization
      }
    },true)
  }

/**数据中心-商品库看板发送排行 */
export function sendRankApi(params,authorization){
  return request({
    url: '/api/wx_shop/dataCenter/sendRank',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },true)
}

/**新商城商品统计 */
export function shopDetailApi(params,authorization){
  return request({
    url: '/api/wx_shop/dataCenter/shopDetail',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },true)
}

/**新商城活动统计 */
export function activityDetailApi(params,authorization){
  return request({
    url: '/api/wx_shop/activity/detail',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },true)
}

